export const COMPARISON_ROW_ATTRIBUTE = 'data-comparison-row';
